import React, { useEffect } from 'react';
import { Button } from '@carvana/core-helios-button';
import IssueSubmittedIcon from '../../../../assets/issue-submitted.svg';
import styles from './coverage.module.css';

export const IssueSubmitted = () => {
  useEffect(() => {
    const modalContent = document.getElementById('modal-content');
    if (modalContent) {
      modalContent.style.height = '100%';
    }

    return () => {
      if (modalContent) {
        modalContent.style.height = '';
      }
    };
  }, []);

  return (
    <div className={styles['coverage']} style={{ justifyContent: 'center', alignItems: 'center' }}>
      <div className={styles['coverage-contact']}>
        <img src={IssueSubmittedIcon} alt="Issue Submitted" />
        <div>Your issue is submitted</div>
        <p>We will email you within 48 hours with next steps.</p>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          className={styles['ok-button']}
        >
          Ok
        </Button>
      </div>
    </div>
  );
};
